<a
  #anchor
  container="body"
  tooltipClass="tooltip-upgradable-item"
  [class.menu-item-locked]="isLocked"
  triggers="mouseenter:manual"
  #tooltip="ngbTooltip"
  [class]="classList"
  [placement]="placement"
  [autoClose]="false"
  [animation]="false"
  [openDelay]="200"
  [ngbTooltip]="lockedItemTooltip"
  [routerLink]="routerLink"
  routerLinkActive="active"
  [routerLinkActiveOptions]="routerLinkActiveOptions"
  (mouseenter)="onLockedItemHover()"
  (mouseleave)="onLockedItemLeave($event)"
  (hidden)="onTooltipClosed()"
  (click)="onLockedItemClick($event)"
>
  <ng-content></ng-content>
</a>

<ng-template #lockedItemTooltip>
  <div
    class="d-flex flex-column upgradeable-tooltip-content"
    (click)="onTooltipContentClick($event)"
    (mouseleave)="onTooltipMouseLeave($event)"
  >
    <!-- Transparent hover bridges covering the arrow gap so the tooltip stays open
         while moving the cursor from the trigger onto it (opt-in via hoverBridge). -->
    <ng-container *ngIf="hoverBridge">
      <div class="tooltip-hover-bridge tooltip-hover-bridge--top"></div>
      <div class="tooltip-hover-bridge tooltip-hover-bridge--bottom"></div>
    </ng-container>

    <!-- INFO SECTION -->
    <ng-container *ngIf="hasInfoTooltip()">
      <div class="tooltip-content">
        <i class="mdi mdi-information-outline tooltip-content-icon text-info"></i>
        <span class="flex-grow-1">{{ getInfoTooltipContent() }}</span>
      </div>
      <hr *ngIf="isLocked" class="my-2" />
    </ng-container>

    <!-- LOCKED SECTION -->
    <ng-container *ngIf="isLocked">
      <div class="tooltip-content">
        <i class="mdi mdi-lock-open-outline tooltip-content-icon text-warning"></i>
        <div class="flex-grow-1">
          <span *ngIf="canUpgrade" class="d-block mb-2">{{ 'sidebar.upgradeTooltip1' | transloco }}</span>
          <span class="d-block mb-2 fw-bold">{{ getTooltipContent() }}</span>
        </div>
      </div>
      <button *ngIf="canUpgrade" class="btn btn-primary btn-card-action w-100" (click)="onUpgradeClick()">
        <span>
          <i class="mdi mdi-lock-open-plus-outline"></i>
          {{'sidebar.upgradeButton' | transloco}}
        </span>
      </button>
    </ng-container>
  </div>
</ng-template>
